import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

import colors from '@packages/core/styles/colors';

const useTableStyles = createUseStyles({
    tableOuter: {
        flex: 1,
        width: '100%',
        overflow: 'auto',
        position: 'relative',
        backgroundColor: colors.white,
        border: `1px solid ${colors.grayThree}`,
    },
    table: {
        width: '100%',
    },
    tableFixed: {
        tableLayout: 'fixed',
        width: '100%',
    },
});

interface TableProps {
    className?: string;
    children?: React.ReactNode;
    /** The class of the inner <table> element; className stays on the outer container. */
    tableClassName?: string;
    useFixedLayout?: boolean;
}

export const Table: FC<TableProps> = React.memo(({ children, className, tableClassName, useFixedLayout = false }) => {
    const classes = useTableStyles();
    const tableClass = `${classes.table} ${useFixedLayout ? classes.tableFixed : ''}`;

    return (
        <div className={classNames(classes.tableOuter, className)}>
            <table className={tableClassName === undefined ? tableClass : `${tableClass} ${tableClassName}`}>
                {children}
            </table>
        </div>
    );
});

Table.displayName = 'Table';
